import {
  Center,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  Flex,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Stack,
  Text,
} from '@chakra-ui/react'
import { CloseIcon, Icon, SearchIcon } from '@chakra-ui/icons'
import { MdArrowDropDown } from 'react-icons/md'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/store'

type DataProps = {
  onClose: () => void
  onSubmit: (year: string) => void
  options: string[] | null | undefined
}
const SelectProductionYear = () => {
  const { onSubmit, onClose, options } = useSelector(
    (state: RootState): DataProps => state.bottomSheet.data,
  )
  const years = options ?? ['1398', '1399', '1400', '1401', '1402']

  return (
    <DrawerContent h='50vh' borderTopRadius='8px' pt='24px' pb='0!'>
      <DrawerHeader
        py='0!'
        px='16px'
        justifyContent='space-between'
        w='full'
        display='flex'
        flexDir='row'
      >
        <Text textStyle='titleXSmall' textColor='text.grey-800'>
          انتخاب مدل (سال تولید)
        </Text>
        <Center>
          <CloseIcon onClick={onClose} boxSize='3' />
        </Center>
      </DrawerHeader>
      <DrawerBody w='full'>
        <Flex w='full' h='full' flexDir='column'>
          <FormControl
            position='sticky'
            variant='floating-icon'
            id='karnameh-app-firs-name'
            mt='24px'
          >
            <InputGroup>
              <Input
                required={false}
                borderRadius='8px'
                type='text'
                w='full'
                py='10px!'
                px='16px'
                outline='0px'
                border='1px'
                placeholder='مدل (سال تولید)'
                _focusVisible={{
                  borderColor: 'accent.enable',
                }}
                borderColor='accent.enable'
                _placeholder={{
                  fontWeight: '400',
                  fontSize: '16px',
                  lineHeight: '32px',
                  color: 'text.secondary',
                }}
              />
              <InputLeftElement>
                <Icon boxSize='18px' as={SearchIcon} color='text.deactive' />
              </InputLeftElement>
              <InputRightElement>
                <Icon boxSize='24px' as={MdArrowDropDown} color='text.secondary' />
              </InputRightElement>
            </InputGroup>

            {/* It is important that the Label comes after the Control due to css selectors */}
            <FormLabel
              _focus={{
                textColor: 'accent.enable',
              }}
              textStyle='captionLargeRegular'
              textColor='accent.enable'
              backgroundColor='white'
            >
              مدل (سال تولید)
            </FormLabel>
          </FormControl>
          <Stack
            filter='drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.05))'
            borderRadius='8px'
            bg='white'
            w='full'
            overflowX='hidden'
            overflowY='auto'
          >
            {years.map((year, index) => {
              return (
                <Text
                  onClick={() => {
                    onSubmit(year.toString())
                  }}
                  textStyle='bodySmallRegular'
                  borderBottom='2px solid'
                  borderColor='background.divider'
                  py='14px!'
                  mx='16px!'
                  key={index}
                >
                  {year}
                </Text>
              )
            })}
          </Stack>
        </Flex>
      </DrawerBody>
    </DrawerContent>
  )
}
export default SelectProductionYear
